import { BsTelephoneFill, BsFacebook, BsInstagram } from "react-icons/bs";
import { RiRestaurant2Fill } from "react-icons/ri";
import { Link } from "react-router-dom";
function Contact() {
    return (
        <>
            <div className="flex flex-col items-center justify-center w-full p-5 pt-40 bg-neutral-100 backdrop-blur-sm font-manrope">
                <h1 className="text-4xl font-extrabold text-center text-neutral-700 md:text-8xl">
                    Contact Information
                </h1>

                <p className="mt-5 text-lg">
                    Questions not answered yet? We are here to help!
                </p>

                <div className="flex flex-row items-baseline mt-40 space-x-10 justify-evenly">
                    <div className="flex flex-col items-center justify-center text-center">
                        <BsTelephoneFill size="40px" />

                        <div className="mt-5 text-xl font-extrabold md:text-3xl">
                            Phone Number
                        </div>
                        <a
                            href="tel:8064075585"
                            className="mt-5 text-xl hover:text-amber-700"
                        >
                            806-407-5585
                        </a>
                    </div>

                    <div className="flex flex-col items-center justify-center">
                        <RiRestaurant2Fill size="50px" />

                        <div className="mt-5 text-center">
                            <p className="text-xl font-extrabold md:text-3xl">
                                Pho District 1
                            </p>

                            <a
                                href="https://goo.gl/maps/jVvjfK2vRUcbBJUf7"
                                target="_blank"
                                className="hover:text-amber-700"
                            >
                                <p className="mt-5 text-xl">
                                    1910 Quaker Ave #106
                                </p>
                                <p className="mt-1 text-xl ">Lubbock, Texas</p>
                                <p className="mt-1 text-xl">79407</p>
                            </a>
                        </div>
                    </div>
                </div>

                <h3 className="mt-20 mb-5 text-xl font-extrabold md:text-3xl">
                    Location
                </h3>

                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13296.34917375069!2d-101.9056167!3d33.5770827!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86fe0d24fbd752ad%3A0x71c4000c24b14941!2sPho%20District%201!5e0!3m2!1sen!2sus!4v1680287686622!5m2!1sen!2sus"
                    style={{ border: 0 }}
                    title="Google Map"
                    className="w-full lg:w-1/2 h-96"
                    allowfullscreen=""
                    referrerpolicy="no-referrer-when-downgrade"
                />

                <h1 className="mt-20 text-2xl font-extrabold text-center md:text-4xl">
                    Social Media
                </h1>

                <div className="flex w-full mb-20 justify-evenly">
                    <a
                        href="https://www.facebook.com/phodistrict106"
                        target="_blank"
                        rel="noreferrer"
                        className="flex flex-col items-center justify-center mt-20 hover:text-amber-700"
                    >
                        <BsFacebook size="50px" />
                        <p className="mt-5 text-center md:text-xl">
                            phodistrict106
                        </p>
                    </a>

                    <a
                        href="https://www.facebook.com/phodistrict106"
                        target="_blank"
                        rel="noreferrer"
                        className="flex flex-col items-center justify-center mt-20 hover:text-amber-700"
                    >
                        <BsInstagram size="50px" />
                        <p className="mt-5 text-center md:text-xl">
                            phodistrictt1_
                        </p>
                    </a>
                </div>
            </div>
        </>
    );
}

export default Contact;
